import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
  state: {
    accidents: [],
    accidentStatuses: [],
    accidentPolicyId: null,
    accidentToEdit: {},
    accidentParentId: null,
  },
  getters: {
    accidents: (state) => state.accidents,
    accidentStatuses: (state) => state.accidentStatuses,
    accidentPolicyId: (state) => state.accidentPolicyId,
    accidentToEdit: (state) => state.accidentToEdit,
    accidentParentId: (state) => state.accidentParentId,
  },
  mutations: {
    setAccidents: (state, data) => {
      state.accidents = data;
    },

    setAccidentStatuses: (state, data) => {
      state.accidentStatuses = data;
    },

    setAccidentPolicyId: (state, data) => {
      state.accidentPolicyId = data;
    },

    setAccidentToEdit: (state, data) => {
      state.accidentToEdit = data;
    },

    setAccidentParentId: (state, data) => {
      state.accidentParentId = data;
    },
  },
  actions: {
    getAccidents: async ({ commit, dispatch }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/policy-accidents"
        );
        const { data } = response.data;
        commit("setAccidents", data);
      } catch (err) {
        console.error(err);
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadAccidents"),
        });
      }
    },

    getAccidentStatuses: async ({ commit, dispatch }) => {
      try {
        const { data } = await api({ requiresAuth: true }).get(
          "/v1/policy-accident-statuses"
        );
        commit("setAccidentStatuses", data.data);
      } catch (err) {
        console.error(err);
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadAccidentStatuses"),
        });
      }
    },

    createAccident: async ({ dispatch }, accident) => {
      try {
        const response = await api({ requiresAuth: true }).post(
          "/v1/policy-accidents",
          { ...accident }
        );
        dispatch("showToast", {
          type: "success",
          message: response.data?.message || t("messages.accidentCreatedSuccessfully"),
        });
        return response;
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToCreateAccident"),
        });
        throw err;
      }
    },

    updateAccident: async ({ dispatch }, accident) => {
      const { accidentId, ...accidentFields } = accident;

      try {
        const response = await api({ requiresAuth: true }).patch(
          `/v1/policy-accidents/${accidentId}`,
          {
            ...accidentFields,
          }
        );
        dispatch("showToast", {
          type: "success",
          message: response.data?.message || t("messages.accidentUpdatedSuccessfully"),
        });
        return response;
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdateAccident"),
        });
        throw err;
      }
    },

    removeAccident: async ({ dispatch }, accidentId) => {
      try {
        const response = await api({ requiresAuth: true }).delete(
          `/v1/policy-accidents/${accidentId}`
        );
        dispatch("showToast", {
          type: "success",
          message: response.data?.message || t("messages.accidentDeletedSuccessfully"),
        });
        return response;
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToDeleteAccident"),
        });
        throw err;
      }
    },

    addAccidentFile: async ({ dispatch }, { accidentId, files }) => {
      try {
        const formData = new FormData();
        files.forEach((file) => {
          formData.append("policy_accident_files[]", file);
        });
        const response = await api({ requiresAuth: true }).post(
          `/v1/policy-accidents/${accidentId}/files`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        dispatch("showToast", {
          type: "success",
          message: response.data?.message || t("messages.accidentFileUploadedSuccessfully"),
        });
        return response;
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUploadAccidentFile"),
        });
        throw err;
      }
    },
  },
};
